import SvgIcon from "./SvgIcon";

export default function YogaIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M10.92 18.06a2.6 2.6 0 001.73-.19l10.59-4.922v-1.7L14.26 6.75l-7.08 3.1-2.25-1.08-.002.004A2.68 2.68 0 003.44 8.58a3.09 3.09 0 00-2.59 3.16 2.58 2.58 0 001.334 2.16v.001l.026.013.05.026v-.002l8.226 3.973.002-.003c.131.06.267.109.407.145l.025.006zm.3-1.314c-.306-.091-.564-.321-.76-.572a1.53 1.53 0 01-.32-.874l1.87.94.31-.18a2.24 2.24 0 001.11-2.56 2.001 2.001 0 00-1.21-1.27l-3.426-1.604L14.23 8.25l7.63 3.86-9.82 4.57a1.19 1.19 0 01-.82.066zm.68-3.13l-.054-.026h-.386a1.45 1.45 0 00-.87.47l1.34.67a.76.76 0 00.23-.77.68.68 0 00-.26-.344zm-7.396-3.553l5.559 2.67A2.81 2.81 0 008.81 14.95v.36c0 .1.006.201.017.301l-5.959-2.878.002-.003a1.23 1.23 0 01-.67-1.06 1.73 1.73 0 011.44-1.75c.295-.054.6 0 .86.15l.004-.007z"
        fill={color}
      />
    </SvgIcon>
  )
}
